import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';
import { ListResponseAPI } from 'src/lib/queries';
import { ServicePlanItem } from 'src/features/servicePlanItems/utils/types';

const RESOURCE = '/subscriptions/service-plan-item/';

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    service_plan?: string[];
    is_required?: boolean;
}

const queryFn = ({ ...params }: DTO): Promise<ListResponseAPI<ServicePlanItem>> => {
    return axios.get(formatResourcePath(RESOURCE), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_SERVICE_PLAN_ITEMS_RESOURCE, useQueryHook as useListServicePlanItems };
